import React from 'react';
import { Alert } from 'react-bootstrap';
import { FiTool } from "react-icons/fi";
import { RiCloseFill } from "react-icons/ri";
import { GlobalAlertConfig } from 'app/services/api/commonTypes';
import { GlobalAlertType } from 'app/shared/constants/constants';

type GlobalAlertProps = {
  show: boolean;
  onClose: () => void;
  globalAlert: GlobalAlertConfig;
};

const GlobalAlert: React.FC<GlobalAlertProps> = ({
 show, onClose, globalAlert,
}) => (
  <Alert
    show={show}
    variant="warning"
    className={`global-alert global-alert-${globalAlert?.type}`}
  >
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div className="alert-main">
        {/* Future improvement: if all alert types need icons, extend the config object
        with an `icon` property and render it here when present */}
        {(globalAlert?.type === GlobalAlertType.MAINTENANCE)
          && <div><FiTool className="brand-icons maintenance-icon"/></div>}
        <div>
          <h2 className="alertHeadingText">{globalAlert?.header}</h2>
          {' '}
          <h2 className="alertBodyText">{globalAlert?.message}</h2>
        </div>
      </div>
      <div>
        <RiCloseFill className="brand-icons alert-close-btn" aria-label="Close" onClick={onClose} />
      </div>
    </div>
  </Alert>
  );

export default GlobalAlert;
